<div class="batch-overrides-component">
  <header class="batch-overrides__header">
    <h2>{{ "taxReturns.batch-overrides" | transloco }}</h2>
  </header>

  @if (taxReturnStructure ) {
  <div class="batch-overrides__body">
    <div class="left">
      <div class="structure">
        @for (category of taxReturnStructure; track category) {
        <div class="category" [hidden]="!category.isVisible">
          <div (click)="category.isCollapsed = !category.isCollapsed">
            <i
              class="chevron icon"
              [ngClass]="{
                down: category.isCollapsed,
                up: !category.isCollapsed
              }"
            ></i>
            <span class="title title-heavy">
              {{ category.name }}
            </span>
          </div>
          @for (subCategory of category.subcategories; track subCategory) {
          <div
            [hidden]="category.isCollapsed || !subCategory.isVisible"
            class="structure-item subcategory"
          >
            <div (click)="subCategory.isCollapsed = !subCategory.isCollapsed">
              <i
                class="chevron icon"
                [ngClass]="{
                  down: subCategory.isCollapsed,
                  up: !subCategory.isCollapsed
                }"
              ></i>
              <span class="title title-heavy">
                {{ subCategory.name }}
              </span>
            </div>
            @for (question of subCategory.questions; track question) {
            <div
              [hidden]="subCategory.isCollapsed"
              class="structure-item question"
            >
              <div>
                <input
                  type="checkbox"
                  [checked]="markedQuestions[question.id]"
                  (change)="markQuestion(question)"
                />
                <span
                  class="title"
                  [ngClass]="{
                    'title-heavy': selectedQuestion?.id === question.id
                  }"
                  (click)="selectQuestion(question)"
                >
                  {{ question.id }}. {{ question.question }} ({{
                    question.taxReturns.length
                  }})
                </span>
              </div>
              @for (taxReturn of question.taxReturns; track taxReturn) {
              <div class="structure-item taxpayers">
                {{ taxReturn.atlasId }}. {{ taxReturn.firstName }}
                {{ taxReturn.lastName }} &#8618;
                <a
                  class="link"
                  [href]="
                    gotoTaxReturnQuestionSectionUrl(
                      taxReturn,
                      subCategory,
                      question
                    )
                  "
                  target="_blank"
                  >{{ "taxReturns.go-to-section" | transloco }}</a
                >
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
    </div>
    <div #rulesBody class="right rules-boundary">
      @if (selectedQuestion) {
      <div class="answer-overrides">
        @if (selectedAnswer) {
        <div id="hints" cdkDrag cdkDragBoundary=".rules-boundary">
          <div id="hints-container">
            <div (click)="selectedAnswer = null" class="delete icon"></div>
            <div>
              <p>
                <strong>{{
                  "taxReturns.override-information" | transloco
                }}</strong>
              </p>
              <p>
                {{ "taxReturns.answer-changed-from" | transloco }} '{{
                  selectedAnswer.answerAudit.oldAnswer
                }}' {{ "taxReturns.to" | transloco }} '{{
                  selectedAnswer.answerAudit.newAnswer
                }}'
              </p>
              <p>
                <i>"{{ selectedAnswer.comment.message }}"</i>
              </p>
            </div>
          </div>
        </div>
        }
        <div class="answer-overrides-header title">
          {{ selectedQuestion.id }}. {{ selectedQuestion.question }}
        </div>
        <div>
          @if (visibleOverrideTables) {
          <div class="table-listing">
            @for (overrideTable of visibleOverrideTables; track
            trackByTable($index, overrideTable)) {
            <div class="table-card">
              <div class="table-card-header">
                <div class="title">
                  {{ overrideTable.header.label }}
                </div>
              </div>
              <table
                cellpadding="0"
                cellspacing="0"
                class="sticky-header table-card-body"
              >
                <thead class="table-header">
                  <tr>
                    <th class="row-num"></th>
                    @for (question of overrideTable.subGroup.questions; track
                    question) { @if (!question.hidden && !question.toggleOff) {
                    <th
                      title="{{ question.question }}"
                      [ngClass]="{
                        'checkbox-column': isBooleanCheckboxColumn(question)
                      }"
                    >
                      <span class="text-ellipsis">
                        @if (question.mandatory) {
                        <span
                          class="column-mandatory"
                          title="This column is mandatory"
                          >*</span
                        >
                        }
                        {{ question.question }}
                      </span>
                    </th>
                    } }
                  </tr>
                </thead>
                <tbody class="table-body">
                  @for (rowAnswer of overrideTable.visibleRows; track
                  trackByRow(index, rowAnswer); let index = $index) {
                  <app-question-table-row
                    (click)="onRowClicked(rowAnswer, overrideTable)"
                    [rowAnswer]="rowAnswer"
                    [subGroup]="overrideTable.subGroup"
                    [formGroup]="overrideTable.formGroup"
                    [groupId]="overrideTable.subGroup.id"
                    [rowIndex]="index"
                    [deleted]="false"
                    [readonly]="true"
                    [readonlyGlobal]="true"
                    [hideClearOverRideQuestionIcon]="true"
                  ></app-question-table-row>
                  }
                </tbody>
              </table>
              @if (overrideTable.hasMoreRows) {
              <button
                class="ui primary background button approve"
                (click)="loadMoreRows(overrideTable)"
              >
                {{ "taxReturns.load-more-rows" | transloco }}
              </button>
              }
            </div>
            }
            <div class="load-more-tables">
              @if (hasMoreTables) {
              <button
                class="ui primary background button approve"
                (click)="loadMoreTables()"
              >
                {{ "taxReturns.load-more-tables" | transloco }}
              </button>
              }
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>
